<template>
  <GatewayIcon 
    :status="gateway?.connectionStatus" 
    :sync="gateway?.syncStatus" 
    :type="gateway?.type"
  />
</template>

<script setup lang="ts">
import type { qx_Gateway } from '@/graphql/types';

type GatewaySmartIconGateway = Pick<qx_Gateway, 'connectionStatus' | 'syncStatus' | 'type'>;

const props = withDefaults(defineProps<{
  gateway?: GatewaySmartIconGateway | null;
}>(), {
  gateway: undefined
});

</script>
